import styled from 'styled-components';
import { SContainerField } from '../styles';

interface BaseFieldWrapperProps {
    withError?: boolean;
    semi?: boolean;
}

export const SFormGroup = styled(SContainerField)<BaseFieldWrapperProps>`
    width: ${({ semi }) => (semi ? '48%' : '100%')};
`;

export const SPasswordWrapper = styled.div<BaseFieldWrapperProps>`
    position: relative;
    display: flex;
    align-items: center;

    & input {
        width: 100%;
        border-radius: ${({ theme }) => theme.form.input.borderRadius};
        border: 1px solid ${({ theme, withError }) => (withError ? theme.color.error.main : theme.color.grey.light)};
        font-family: ${({ theme }) => theme.font};
        font-size: 14px;
        color: ${({ theme }) => theme.color.text.main};
        padding: 8px 40px 8px 8px;
        box-sizing: border-box;

        &::placeholder {
            color: ${({ theme }) => theme.color.text.light};
        }

        &:disabled {
            background-color: ${({ theme }) => theme.color.grey.lighter};
        }

        &:focus {
            border-color: ${({ theme, withError }) =>
                withError ? theme.color.primary.main : theme.color.secondary.main};
            outline: 0;
        }
    }
`;

export const SToggleButton = styled.button`
    position: absolute;
    right: 8px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.color.text.light};
    transition: color 0.2s ease;

    &:hover {
        color: ${({ theme }) => theme.color.text.main};
    }

    &:focus {
        outline: 2px solid ${({ theme }) => theme.color.secondary.main};
        outline-offset: 2px;
        border-radius: 2px;
    }

    svg {
        width: 18px;
        height: 18px;
    }
`;
